import { DomainEvent } from "../model/domain-event.model";

export class ServiceFinalizedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor() {}
}